const url = "./assets/page/payment/";

const options = [
    {
        content: "money",
        icon: true,
        text: "Dinheiro",
        url: `${url}money.svg`,
    },
    {
        content: "card",
        icon: true,
        text: "Cartão",
        url: `${url}card.svg`,
    },
    {
        content: "pix",
        icon: true,
        text: "Pix",
        url: `${url}pix.svg`,
    },
];

export default options;
